import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { Avatar } from "@faire/web--source/slate/Avatar";
import { AddUser } from "@faire/web--source/slate/icons/foundation/AddUser";
import { Chevron } from "@faire/web--source/slate/icons/foundation/Chevron";
import { Input, InputWrapper } from "@faire/web--source/slate/Input";
import { Column, Row } from "@faire/web--source/slate/Layout";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { Tag } from "@faire/web--source/slate/Tag";
import { Typography } from "@faire/web--source/slate/Typography";
import ClickOutside from "@faire/web--source/ui/ClickOutside";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { trackRetailerTeamManagementInviteTeamMemberDropdownItemClick } from "@faire/web-api--source/events/retailerTeamManagement/click/inviteTeamMemberDropdownItem";
import React, { useState } from "react";
import styled from "styled-components";
import { CapabilitySpecificComponent } from "@faire/retailer-visitor-shared/components/Capabilities/CapabilitySpecificComponent";
import { includesSearchValue } from "@faire/retailer-visitor-shared/views/multi-user/Share/__internal__/util";
export var SelectTeamUsersDropdown = function(param) {
    var options = param.options, selectedUsers = param.selectedUsers, onSelect = param.onSelect, pageName = param.pageName, onInviteButtonClick = param.onInviteButtonClick, errorMessage = param.errorMessage, setErrorMessage = param.setErrorMessage;
    var strictLocalize = useStrictLocalization().strictLocalize;
    var _useState = _sliced_to_array(useState(false), 2), isDropdownOpen = _useState[0], setIsDropdownOpen = _useState[1];
    var _useState1 = _sliced_to_array(useState(""), 2), searchValue = _useState1[0], setSearchValue = _useState1[1];
    var filteredUserOptions = options.filter(function(option) {
        var _option_user_token, _option_full_name, _option_email;
        return !selectedUsers.flatMap(function(o) {
            return o.user_token;
        }).includes((_option_user_token = option.user_token) !== null && _option_user_token !== void 0 ? _option_user_token : "") && (includesSearchValue((_option_full_name = option.full_name) !== null && _option_full_name !== void 0 ? _option_full_name : "", searchValue) || includesSearchValue((_option_email = option.email) !== null && _option_email !== void 0 ? _option_email : "", searchValue));
    });
    var showNoResultsSection = filteredUserOptions.length === 0 && searchValue;
    var handleInviteButtonClick = function() {
        trackRetailerTeamManagementInviteTeamMemberDropdownItemClick(pageName);
        onInviteButtonClick === null || onInviteButtonClick === void 0 ? void 0 : onInviteButtonClick();
    };
    var handleCloseDropdown = function() {
        setSearchValue("");
        setIsDropdownOpen(false);
    };
    var handleInputClick = function(e) {
        if (isDropdownOpen) {
            handleCloseDropdown();
        } else {
            setIsDropdownOpen(true);
        }
        e.preventDefault();
        e.stopPropagation();
    };
    var handleInputChange = function(e) {
        setIsDropdownOpen(true);
        setSearchValue(e.target.value);
    };
    var handleSelectValue = function(value) {
        return function() {
            setErrorMessage(undefined);
            if (selectedUsers.flatMap(function(user) {
                return user.user_token;
            }).includes(value.user_token)) {
                // remove user
                onSelect(selectedUsers.filter(function(v) {
                    return v.user_token !== value.user_token;
                }));
            } else {
                // add user
                onSelect(_to_consumable_array(selectedUsers).concat([
                    value
                ]));
                handleCloseDropdown();
            }
        };
    };
    return /*#__PURE__*/ _jsxs(Column, {
        children: [
            /*#__PURE__*/ _jsx(ClickOutside, {
                onClickOutside: handleCloseDropdown,
                children: /*#__PURE__*/ _jsxs(Wrapper, {
                    children: [
                        /*#__PURE__*/ _jsx(Input, {
                            label: strictLocalize({
                                id: "su9wT5",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "Team member(s)"
                                    }
                                ]
                            }),
                            "data-test-id": "select-team-users-dropdown-input",
                            placeholder: isDropdownOpen || errorMessage ? strictLocalize({
                                id: "pSSQa1",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "Select team member"
                                    }
                                ]
                            }) : undefined,
                            value: searchValue,
                            onChange: handleInputChange,
                            onClick: handleInputClick,
                            error: errorMessage
                        }),
                        isDropdownOpen ? /*#__PURE__*/ _jsxs(Dropdown, {
                            children: [
                                /*#__PURE__*/ _jsx(DropdownResults, {
                                    align: "center",
                                    "data-test-id": "select-team-users-dropdown",
                                    children: filteredUserOptions.map(function(user) {
                                        return /*#__PURE__*/ _jsxs(DropdownItem, {
                                            onClick: handleSelectValue(user),
                                            children: [
                                                /*#__PURE__*/ _jsx(Avatar, {
                                                    image: user.avatar,
                                                    size: "smaller"
                                                }),
                                                /*#__PURE__*/ _jsx(Spacer, {
                                                    size: "2x"
                                                }),
                                                /*#__PURE__*/ _jsxs(Column, {
                                                    style: {
                                                        maxWidth: "70%"
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ _jsx(Typography, {
                                                            variant: "paragraphSansMedium",
                                                            truncate: true,
                                                            children: user.full_name
                                                        }),
                                                        /*#__PURE__*/ _jsx(Typography, {
                                                            truncate: true,
                                                            children: user.email
                                                        })
                                                    ]
                                                })
                                            ]
                                        }, user.user_token);
                                    })
                                }),
                                showNoResultsSection ? /*#__PURE__*/ _jsxs(_Fragment, {
                                    children: [
                                        /*#__PURE__*/ _jsx(DividerLine, {}),
                                        /*#__PURE__*/ _jsx(NonSelectableDropdownItem, {
                                            children: /*#__PURE__*/ _jsx(Typography, {
                                                color: Core.text.subdued,
                                                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                                                    id: "S4K+7N",
                                                    defaultMessage: [
                                                        {
                                                            type: 0,
                                                            value: "No results"
                                                        }
                                                    ]
                                                })
                                            })
                                        })
                                    ]
                                }) : null,
                                /*#__PURE__*/ _jsxs(CapabilitySpecificComponent, {
                                    capability: "RETAILER_INVITE_ACCOUNT_USER",
                                    errorComponent: null,
                                    children: [
                                        /*#__PURE__*/ _jsx(DividerLine, {}),
                                        /*#__PURE__*/ _jsx(DropdownItem, {
                                            children: /*#__PURE__*/ _jsxs(InviteUserWrapper, {
                                                justify: "space-between",
                                                align: "center",
                                                onClick: handleInviteButtonClick,
                                                children: [
                                                    /*#__PURE__*/ _jsxs(Row, {
                                                        align: "center",
                                                        children: [
                                                            /*#__PURE__*/ _jsx(AddUser, {
                                                                strokeWidth: 2,
                                                                fontSize: "16px"
                                                            }),
                                                            /*#__PURE__*/ _jsx(Spacer, {
                                                                size: "2x"
                                                            }),
                                                            /*#__PURE__*/ _jsx(Typography, {
                                                                variant: "paragraphSansMedium",
                                                                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                                                                    id: "sbGy4z",
                                                                    defaultMessage: [
                                                                        {
                                                                            type: 0,
                                                                            value: "Invite a team member"
                                                                        }
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsx(Chevron, {
                                                        fontSize: "16px",
                                                        direction: "right"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        }) : null
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: "1x"
            }),
            /*#__PURE__*/ _jsx(SelectedUsers, {
                gap: 4,
                children: selectedUsers.map(function(value) {
                    var _value_full_name;
                    return /*#__PURE__*/ _jsx(Tag, {
                        label: (_value_full_name = value.full_name) !== null && _value_full_name !== void 0 ? _value_full_name : "",
                        onClose: handleSelectValue(value),
                        "data-test-id": "".concat(value.user_token, "-tag")
                    }, value.user_token);
                })
            })
        ]
    });
};
var Wrapper = styled(Column).withConfig({
    componentId: "sc-9f6384f1-0"
})([
    "position:relative;",
    "{cursor:pointer;}"
], InputWrapper);
var Dropdown = styled(Column).withConfig({
    componentId: "sc-9f6384f1-1"
})([
    "left:0;right:0;bottom:0;z-index:1;position:absolute;transform:translateY(100%);background-color:",
    ";border:1px solid ",
    ";border-top:0;"
], Core.surface.inverse, Core.border.muted);
// eslint-disable-next-line @faire/prefer-slate-attrs -- false alarm
var DropdownResults = styled(Column).withConfig({
    componentId: "sc-9f6384f1-2"
})([
    "max-height:192px;overflow-y:auto;-ms-overflow-style:none;scrollbar-width:none;&::-webkit-scrollbar{display:none;}"
]);
var DropdownItem = styled(Row).attrs({
    align: "center"
}).withConfig({
    componentId: "sc-9f6384f1-3"
})([
    "padding:",
    ";width:100%;cursor:pointer;min-height:64px;background-color:",
    ";&:hover{background-color:",
    ";}"
], getSpacing("1x", "2x"), Core.surface.inverse, Core.surface.subdued);
var NonSelectableDropdownItem = styled(DropdownItem).withConfig({
    componentId: "sc-9f6384f1-4"
})([
    "cursor:default;&:hover{background-color:",
    ";}"
], Core.surface.inverse);
var InviteUserWrapper = styled(Row).withConfig({
    componentId: "sc-9f6384f1-5"
})([
    "width:100%;"
]);
// eslint-disable-next-line @faire/prefer-slate-attrs -- false alarm
var SelectedUsers = styled(Row).withConfig({
    componentId: "sc-9f6384f1-6"
})([
    "flex-wrap:wrap;max-height:110px;overflow-y:auto;padding:",
    ";-ms-overflow-style:none;scrollbar-width:none;&::-webkit-scrollbar{display:none;}"
], getSpacing("1x", 0));
var DividerLine = styled.div.withConfig({
    componentId: "sc-9f6384f1-7"
})([
    "position:relative;height:0;width:100%;border-top:1px solid ",
    ";"
], Core.border.muted);
